// extracted by mini-css-extract-plugin
export var closeButton = "_ex-2";
export var closeButtonIcon = "_ex-3";
export var lightboxContent = "_ex-1";
export var lightboxOverlay = "_ex-0";